<!-- Footer -->
<footer class="footer">
  <div class="footer-content">
    <!-- Linki nawigacyjne -->
    <div class="footer-links">
      <a mat-button routerLink="/kontakt">Kontakt</a>
      <a mat-button routerLink="/polityka-prywatnosci">Polityka prywatności</a>
      <a mat-button routerLink="/regulamin">Regulamin</a>
    </div>

    <!-- Ikony mediów społecznościowych -->
    <div class="social-icons">
      <a
        mat-icon-button
        href="https://www.facebook.com/guaranaimpro"
        target="_blank"
        aria-label="Facebook"
      >
        <i class="fab fa-facebook"></i>
      </a>
      <a
        mat-icon-button
        href="https://www.instagram.com/guaranaimpro"
        target="_blank"
        aria-label="Instagram"
      >
        <i class="fab fa-instagram"></i>
      </a>
      <a
        mat-icon-button
        href="https://www.youtube.com/@GuaranaImpro"
        target="_blank"
        aria-label="YouTube"
      >
        <i class="fab fa-youtube"></i>
      </a>
    </div>
  </div>

  <!-- Informacje o firmie -->
  <div class="footer-bottom">
    <p>&copy; 2024 Guarana Impro – Wszystkie prawa zastrzeżone</p>
  </div>
</footer>
